import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { MattersmapService } from './components/mattermaps-edit/services/mattersmap.service';

@Component({
  selector: 'app-mattermaps',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './mattermaps.component.html',
  styleUrls: ['./mattermaps.component.scss'],
  providers: [MattersmapService]
})
export class MattermapsComponent {
}
